(function () {
  // Reparations ARIA que le theme ne peut pas faire lui-meme, parce que Slick et Swiper
  // reecrivent le DOM apres le rendu serveur.
  //
  // 1. Slick deplace les <li> des vignettes produit dans .slick-track : le <ul> se retrouve
  //    avec des <button> et un <div> en enfants directs, et les <li> n'ont plus de liste
  //    parente. On rend le <ul> presentationnel et on porte la semantique sur la piste.
  // 2. Le theme pose role="list" sur des conteneurs de grille qui contiennent des <img>,
  //    des titres ou des liens directs. Un role="list" sans listitem casse la restitution
  //    vocale : on le retire, le conteneur redevient un simple bloc.

  function estListitem(el) {
    var r = el.getAttribute("role");
    return el.tagName === "LI" || r === "listitem" || r === "presentation" || r === "none";
  }

  function passe() {
    document.querySelectorAll("ul.thumbnail-list").forEach(function (ul) {
      var piste = ul.querySelector(":scope > .slick-list > .slick-track");
      if (!piste) return;
      ul.setAttribute("role", "presentation");
      if (piste.getAttribute("role") !== "list") piste.setAttribute("role", "list");
    });

    // 3. Swiper pose role="group" sur ses diapositives. Quand la piste est un vrai <ul>,
    //    ces <li> cessent d'etre des elements de liste et la liste devient invalide.
    //    On retire le role, l'etiquette "1 / 4" reste.
    document.querySelectorAll("ul.swiper-wrapper > li[role=group], ol.swiper-wrapper > li[role=group]").forEach(
      function (li) { li.removeAttribute("role"); }
    );

    document.querySelectorAll('[role="list"]').forEach(function (n) {
      if (n.tagName === "UL" || n.tagName === "OL") return;
      var enfants = Array.prototype.filter.call(n.children, function (c) {
        return c.tagName !== "SCRIPT" && c.tagName !== "STYLE" && c.tagName !== "TEMPLATE";
      });
      if (!enfants.length) return;
      var tous = enfants.every(estListitem);
      if (!tous) n.removeAttribute("role");
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", passe);
  else passe();
  // Slick et Swiper finissent leur initialisation apres le premier passage.
  setTimeout(passe, 1200);
  setTimeout(passe, 3500);
  setTimeout(passe, 7000);
})();
